import { createSlice } from "@reduxjs/toolkit";
import { getTopSoldProducts } from "./topSoldProductsAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  products:[],
  latestRequestId: null,
};

const topSoldProductSlice = createSlice({
  name: "topSoldProducts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopSoldProducts.pending, (state, action) => {
        state.loading = true;
        state.products = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getTopSoldProducts.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.products = action.payload;
        state.error = null;
      })
      .addCase(getTopSoldProducts.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default topSoldProductSlice.reducer;